// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProjectsTabPage_pageContainer__Ew8jO"};